module.exports = __webpack_public_path__ + "img/error.8e06c53f.gif";